/* Junemae listicle: countdowns + sticky CTA. Loaded by several sections, runs once. */
(function () {
  if (window.JMListicle) return;

  function pad(n) { return String(n).padStart(2, '0'); }

  function parseEnd(value) {
    if (!value) return null;
    var m = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    // Local time of the visitor: the sale ends at that clock time wherever she is.
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59).getTime();
  }

  function endFor(el) {
    var mode = el.dataset.mode || 'deadline';
    var now = Date.now();
    var deadline = parseEnd(el.dataset.end);
    if (mode === 'deadline' && deadline && deadline > now) return deadline;
    if (mode === 'evergreen' || (deadline && deadline <= now && el.dataset.after === 'evergreen')) {
      var hours = parseFloat(el.dataset.hours || '2') || 2;
      var key = 'jml_cd_' + (el.dataset.key || 'default');
      var stored = null;
      try { stored = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (!stored || stored <= now) {
        stored = now + hours * 3600 * 1000;
        try { localStorage.setItem(key, String(stored)); } catch (e) {}
      }
      return stored;
    }
    if (deadline && deadline <= now && el.dataset.after === 'midnight') {
      var d = new Date(); d.setHours(23, 59, 59, 0); return d.getTime();
    }
    return deadline;
  }

  function initCountdown(el) {
    if (el.dataset.jmlReady === '1') return;
    el.dataset.jmlReady = '1';
    var end = endFor(el);
    var parts = {
      days: el.querySelector('[data-days]'),
      hours: el.querySelector('[data-hours]'),
      minutes: el.querySelector('[data-minutes]'),
      seconds: el.querySelector('[data-seconds]')
    };
    var dayItem = el.querySelector('[data-unit="days"]');
    var expired = el.parentNode && el.parentNode.querySelector('[data-countdown-expired][data-for="' + el.id + '"]');

    function tick() {
      var dist = end ? end - Date.now() : 0;
      if (!end || dist <= 0) {
        el.dataset.state = 'expired';
        if (expired) expired.hidden = false;
        clearInterval(timer);
        return;
      }
      var days = Math.floor(dist / 86400000);
      var hours = Math.floor((dist % 86400000) / 3600000);
      var minutes = Math.floor((dist % 3600000) / 60000);
      var seconds = Math.floor((dist % 60000) / 1000);
      var showDays = days > 0 && el.dataset.days !== 'false';
      if (dayItem) dayItem.hidden = !showDays;
      if (dayItem && dayItem.nextElementSibling) dayItem.nextElementSibling.hidden = !showDays;
      if (!showDays) hours += days * 24;
      if (parts.days) parts.days.textContent = pad(days);
      if (parts.hours) parts.hours.textContent = pad(hours);
      if (parts.minutes) parts.minutes.textContent = pad(minutes);
      if (parts.seconds) parts.seconds.textContent = pad(seconds);
      el.dataset.state = 'running';
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  function initSticky(el) {
    if (el.dataset.jmlReady === '1') return;
    el.dataset.jmlReady = '1';
    var showAfter = parseInt(el.dataset.showAfter || '500', 10);
    var hideTargets = document.querySelectorAll('[data-jml-hide-sticky]');
    var targetVisible = false;
    function update() {
      var visible = window.scrollY > showAfter && !targetVisible;
      el.classList.toggle('is-visible', visible);
      el.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.documentElement.style.setProperty('--jml-sticky-space', visible ? el.offsetHeight + 'px' : '0px');
    }
    if ('IntersectionObserver' in window && hideTargets.length) {
      var seen = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        targetVisible = Array.from(seen.values()).some(Boolean);
        update();
      }, { threshold: 0.15 });
      hideTargets.forEach(function (t) { io.observe(t); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-jml-countdown]').forEach(initCountdown);
    (root || document).querySelectorAll('[data-jml-sticky]').forEach(initSticky);
  }

  window.JMListicle = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
